export class AgentConst {
  static displayColumns = (fields: any[] = []) => {
    let data = [
      {
        title: 'Chuyên viên',
        key: 'name',
        display: true,
        allowSort: false,
        classes: '',
        field: 'name',
      },
      {
        title: 'Số lần gọi',
        key: 'total_call',
        display: true,
        allowSort: false,
        classes: '',
        field: 'total_call',
      },
      {
        title: 'Gọi thành công',
        key: 'success_call',
        display: true,
        allowSort: false,
        classes: '',
        field: 'success_call',
      },
      {
        title: 'Không nghe máy',
        key: 'not_answer_call',
        display: true,
        allowSort: false,
        classes: '',
        field: 'not_answer_call',
      },
      {
        title: 'Không kết nối được',
        key: 'display_error_call',
        display: true,
        allowSort: false,
        classes: '',
        field: 'error_call',
      },
    ];
    if (fields.length > 0) {
      fields.forEach(f => {
        const fData = f.data || [];
        for (let i = 0; i < fData.length; i++) {
          data.push({
            title: f.title + ': ' + fData[i],
            key: f.key + i,
            display: f.display,
            allowSort: false,
            classes: '',
            field: f.key,
          });
        }
      });
    }
    return data;
  };
  static customFields = (fields: any[] = []) => {
    let data = [
      {
        title: 'Chuyên viên',
        key: 'name',
        display: true,
        allowSort: false,
        classes: '',
        field: 'name',
      },
      {
        title: 'Số lần gọi',
        key: 'total_call',
        display: true,
        allowSort: false,
        classes: '',
        field: 'total_call',
      },
      {
        title: 'Gọi thành công',
        key: 'success_call',
        display: true,
        allowSort: false,
        classes: '',
        field: 'success_call',
      },
      {
        title: 'Không nghe máy',
        key: 'not_answer_call',
        display: true,
        allowSort: false,
        classes: '',
        field: 'not_answer_call',
      },
      {
        title: 'Kết nối được',
        key: 'display_error_call',
        display: true,
        allowSort: false,
        classes: '',
        field: 'error_call',
      },
    ];
    if (fields.length > 0) {
      fields.forEach(f => {
        data.push({
          title: f.title,
          key: f.key,
          display: false,
          allowSort: false,
          classes: '',
          field: f.key,
        });
      });
    }
    return data;
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/campaign/detail/agents/agent.const.ts